module.exports = "/assets/b5a1abb44e2513e7e9e92e75fb825c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KL.png
// module id = 2673
// module chunks = 0